import { AUTH_URL } from 'src/constants/global'
import { useFetchCb } from '@gluedigital/ruse-fetch-extras'

export interface SignupData {
  name: string
  surname: string
  email: string
  phone: string
  company: string
  role: string
  recaptchaToken: string
  from?: string
}

interface SignupResponse {
  ok: boolean
  id?: string
}

export default function useAuthSignup() {
  const doFetch = useFetchCb()

  const signup = async (data: SignupData): Promise<SignupResponse> => {
    const res = (await doFetch(AUTH_URL + '/auth/signup', {
      method: 'POST',
      body: data
    })) as SignupResponse

    return res
  }
  return { signup }
}
